export const BASE_URL = "https://al-munir.s3.us-east-1.amazonaws.com";
